/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Text_ReadabilityInputs */

const en_text_readability = /** @type {(inputs: Text_ReadabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text Readability`)
};

const id_text_readability = /** @type {(inputs: Text_ReadabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keterbacaan Teks`)
};

/** @type {(inputs: Text_ReadabilityInputs) => LocalizedString} */
const es_text_readability = en_text_readability;

/** @type {(inputs: Text_ReadabilityInputs) => LocalizedString} */
const fr_text_readability = en_text_readability;

/** @type {(inputs: Text_ReadabilityInputs) => LocalizedString} */
const de_text_readability = en_text_readability;

/** @type {(inputs: Text_ReadabilityInputs) => LocalizedString} */
const ja_text_readability = en_text_readability;

/** @type {(inputs: Text_ReadabilityInputs) => LocalizedString} */
const zh_text_readability = en_text_readability;

/** @type {(inputs: Text_ReadabilityInputs) => LocalizedString} */
const ar_text_readability = en_text_readability;

/** @type {(inputs: Text_ReadabilityInputs) => LocalizedString} */
const it_text_readability = en_text_readability;

/** @type {(inputs: Text_ReadabilityInputs) => LocalizedString} */
const ru_text_readability = en_text_readability;

/** @type {(inputs: Text_ReadabilityInputs) => LocalizedString} */
const pt_text_readability = en_text_readability;

/** @type {(inputs: Text_ReadabilityInputs) => LocalizedString} */
const ko_text_readability = en_text_readability;

/**
* | output |
* | --- |
* | "Text Readability" |
*
* @param {Text_ReadabilityInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const text_readability = /** @type {((inputs?: Text_ReadabilityInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Text_ReadabilityInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_text_readability(inputs)
	if (locale === "es") return es_text_readability(inputs)
	if (locale === "fr") return fr_text_readability(inputs)
	if (locale === "de") return de_text_readability(inputs)
	if (locale === "ja") return ja_text_readability(inputs)
	if (locale === "zh") return zh_text_readability(inputs)
	if (locale === "ar") return ar_text_readability(inputs)
	if (locale === "id") return id_text_readability(inputs)
	if (locale === "it") return it_text_readability(inputs)
	if (locale === "ru") return ru_text_readability(inputs)
	if (locale === "pt") return pt_text_readability(inputs)
	return ko_text_readability(inputs)
});